import { Box, Button, ButtonGroup, Container, Paper, Stack, Typography } from "@mui/material";
import '@mdxeditor/editor/style.css'
import { BlockTypeSelect, BoldItalicUnderlineToggles, CreateLink, InsertImage, ListsToggle, MDXEditor, Separator, UndoRedo, headingsPlugin, imagePlugin, linkDialogPlugin, linkPlugin, listsPlugin, quotePlugin, thematicBreakPlugin, toolbarPlugin } from '@mdxeditor/editor'
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { queryArticle, queryArticleDraft } from "../../utils/queryArticles";
import { Article } from "../../types/Article";
import { DraftsRounded, PublishRounded, SaveAsRounded } from "@mui/icons-material";
import { ArticleEditor } from "./ArticleEditor";

export const EditArticle = () => {
    const { articleId } = useParams()

    const [article, setArticle] = useState<Article | undefined>(undefined);
    const [draftArticle, setDraftArticle] = useState<Article | undefined>(undefined);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (articleId !== undefined) {
            setLoading(true);
            queryArticle(articleId)
                .then((article) => {
                    setArticle(article);
                    return queryArticleDraft(articleId);
                })
                .then((draftArticle) => {
                    setDraftArticle(draftArticle);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [articleId]);

    if (loading) {
        return (
            <Box>
                <Typography>Loading...</Typography>
            </Box>
        );
    }

    return (
        <Container disableGutters>
            <ArticleEditor 
                article={draftArticle ?? article} 
                publishedArticle={article} 
                onUnpublished={setArticle}
                onDraftDeleted={() => {
                    setArticle(article);
                    setDraftArticle(article);
                }}
                onDraftSaved={setDraftArticle}
            />
        </Container>
    );
};